/**
 * Which environment this build is: production, sandbox or development
 * (ADR sandbox-before-live, docs/ENVIRONMENTS.md).
 *
 * Read from `VITE_ENVIRONMENT`, baked in at build time — unlike sign-in, which
 * src/lib/env.ts insists is asked of the server, because this is a fact about
 * the BUILD, not about the server's state, and the banner and the tab title
 * must be right before the first request returns. The trap that note warns of
 * (a build variable silently missing on Railway) is closed a different way:
 * `.railway/railway.ts` sets it as a literal per environment, the Dockerfile
 * declares its ARG, and `railway-config.test.ts` fails if either stops.
 *
 * Optional chaining because the server also loads this file (via lib/brand,
 * for email) and there is no `import.meta.env` outside Vite — which reads as
 * development, never as production.
 */
import { type AppEnvironment, toEnvironment } from '@/core/system/build'

// Typed loosely on purpose: the server's tsconfig has no Vite types, and at
// runtime there it really is undefined.
const viteEnv = (import.meta as { env?: Record<string, string | undefined> }).env

export const appEnvironment: AppEnvironment = toEnvironment(viteEnv?.VITE_ENVIRONMENT)

/** True only in the sandbox build: the banner, the tab title prefix, noindex. */
export const isSandbox = appEnvironment === 'sandbox'
